import svgUrl from "ni:svgr;vzranK_nEHgfRPRF4ET17lOk3c99Yd50TkZNu5r0fzI";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const RightJoinMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><circle cx={8} cy={12} r={8} fill="var(--tbl--colors--icons--transformation--tertiary)" /><circle cx={16} cy={12} r={8} fill="var(--tbl--colors--icons--transformation--primary)" /><path fill="#fff" fillOpacity={0.2} fillRule="evenodd" d="M12 18.93A7.997 7.997 0 0 0 16 12a7.997 7.997 0 0 0-4-6.93A7.997 7.997 0 0 0 8 12a7.997 7.997 0 0 0 4 6.93Z" clipRule="evenodd" /></svg>;
const Memo = memo(RightJoinMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "RightJoinMIcon";
}